/*
 * Default values only add a config if it is other than the default
 *    required: false
 *
 */


export const ZIP_CONFIG = {
    'AF': {
        'Note': 'The first two digits (ranging from 10–43) correspond to the province, while the last two digits correspond either to the city/delivery zone (range 01–50) or to the district/delivery zone (range 51–99). Afghanistan Postal code lookup',
        'Country': 'Afghanistan',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'AX': {
        'Note': 'With Finland, first two numbers are 22.',
        'Country': 'Åland Islands',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'AL': {
        'Note': 'Introduced in 2006, gradually implemented throughout 2007.',
        'Country': 'Albania',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'DZ': {
        'Note': 'First two as in ISO 3166-2:DZ',
        'Country': 'Algeria',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'AS': {
        'Note': 'U.S. ZIP codes (range 96799)',
        'Country': 'American Samoa',
        'Format': 'NNNNN (optionally NNNNN-NNNN or NNNNN-NNNNNN)',
        'required': true,
        'regex': '^\\d{5}(-\\d{4}(\\d{2})?)?$'
    },
    'AD': {
        'Note': 'Each parish now has its own post code.',
        'Country': 'Andorra',
        'Format': 'CCNNN',
        'required': true,
        'regex': '^[Aa][Dd]\\d{3}$'
    },
    'AO': {
        'Note': '',
        'Country': 'Angola',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'AI': {
        'Note': 'Single code used for all addresses.',
        'Country': 'Anguilla',
        'Format': 'AI-2640',
        'required': true,
        'regex': '^[Aa][I][-][2][6][4][0]$'
    },
    'AG': {
        'Note': '',
        'Country': 'Antigua and Barbuda',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'AR': {
        'Note': 'Codigo Postal Argentino (CPA), where the first A is the province code as in ISO 3166-2:AR, the four numbers are the old postal codes, the three last letters indicate a side of the block. Previously NNNN which &amp;#10;o the minimum requirement as of 2006.',
        'Country': 'Argentina',
        'Format': '1974-1998 NNNN; From 1999 ANNNNAAA',
        'required': true,
        'regex': '^\\d{4}|[A-Za-z]\\d{4}[a-zA-Z]{3}$'
    },
    'AM': {
        'Note': 'Previously used NNNNNN system inherited from former Soviet Union.',
        'Country': 'Armenia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'AW': {
        'Note': '',
        'Country': 'Aruba',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'AC': {
        'Note': 'Single code used for all addresses. Part of UK system.',
        'Country': 'Ascension island',
        'Format': 'AAAANAA one code: ASCN 1ZZ',
        'required': true,
        'regex': '^[Aa][Ss][Cc][Nn]\\s?[1][Zz][Zz]$'
    },
    'AU': {
        'Note': 'In general, the first digit identifies the state or territory.',
        'Country': 'Australia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'AT': {
        'Note': 'The first digit denotes regions, which are partly identical to one of the nine provinces—called Bundesländer; the last the nearest post office in the area.',
        'Country': 'Austria',
        'required': true,
        'Format': 'NNNN',
        'regex': '^\\d{4}$'
    },
    'AZ': {
        'Note': 'Previously used NNNNNN system inherited from former Soviet Union.',
        'Country': 'Azerbaijan',
        'Format': 'CCNNNN',
        'required': true,
        'regex': '^[Aa][Zz]\\d{4}$'
    },
    'BS': {
        'Note': '',
        'Country': 'Bahamas',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BH': {
        'Note': "Valid post code numbers are 101 to 1216 with gaps in the range. Known as block number (Arabic: رقم المجمع‎) formally. The first digit in NNN format and the first two digits in NNNN format refer to one of the 12 municipalities of the country. PO Box address doesn't need a block number or city name, just the PO Box number followed by the name of the country, Bahrain.",
        'Country': 'Bahrain',
        'Format': 'NNN or NNNN',
        'required': true,
        'regex': '^\\d{3,4}$'
    },
    'BD': {
        'Note': '',
        'Country': 'Bangladesh',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'BB': {
        'Note': 'Only one postal code currently assigned. 11000 applies to the General Post Office building in Cheapside, Bridgetown, to enable delivery to Barbados by global package delivery companies whose software requires a postal code.',
        'Country': 'Barbados',
        'Format': 'CCNNNNN',
        'required': true,
        'regex': '^[Aa][Zz]\\d{5}$'
    },
    'BY': {
        'Note': 'Retained system inherited from former Soviet Union.',
        'Country': 'Belarus',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'BE': {
        'Note': 'In general, the first digit gives the province.',
        'Country': 'Belgium',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'BZ': {
        'Note': '',
        'Country': 'Belize',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BJ': {
        'Note': '',
        'Country': 'Benin',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BM': {
        'Note': 'AA NN for street addresses, AA AA for P.O. Box addresses. The second half of the postcode identifies the street delivery walk (e.g.: Hamilton HM 12) or the PO Box number range (e.g.: Hamilton HM BX). See Postal codes in Bermuda.',
        'Country': 'Bermuda',
        'Format': 'AA NN or AA AA',
        'required': true,
        'regex': '^[A-Za-z]{2}\\s([A-Za-z]{2}|\\d{2})$'
    },
    'BT': {
        'Note': '',
        'Country': 'Bhutan',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'BO': {
        'Note': '',
        'Country': 'Bolivia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'BQ': {
        'Note': '',
        'Country': 'Bonaire, Sint Eustatius and Saba',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BA': {
        'Note': '',
        'Country': 'Bosnia and Herzegovina',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'BW': {
        'Note': '',
        'Country': 'Botswana',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BR': {
        'Note': 'Código de Endereçamento Postal (CEP): -000 to -899 are used for streets, roads, avenues, boulevards; -900 to -959 are used for buildings with a high postal use; -960 to -969 are for promotional use; -970 to -989 are post offices and regular P.O. boxes; and -990 to -998 are used for community P.O. boxes. -999 is used for special services.',
        'Country': 'Brazil',
        'Format': 'NNNNN-NNN (NNNNN from 1971 to 1992)',
        'required': true,
        'regex': '^\\d{5}-\\d{3}$'
    },
    '': {
        'Note': 'Single code used for all addresses.',
        'Country': 'British Antarctic Territory',
        'Format': 'BIQQ 1ZZ',
        'required': true,
        'regex': '^[Bb][Ii][Qq]{2}\\s?[1][Zz]{2}$'
    },
    'IO': {
        'Note': 'UK territory, but not UK postcode.',
        'Country': 'British Indian Ocean Territory',
        'Format': 'AAAANAA one code: BBND 1ZZ',
        'required': true,
        'regex': '^[Bb]{2}[Nn][Dd]\\s?[1][Zz]{2}$'
    },
    'VG': {
        'Note': 'Specifically, VG1110 through VG1160[1]',
        'Country': 'British Virgin Islands',
        'Format': 'CCNNNN',
        'required': true,
        'regex': '^[Vv][Gg]\\d{4}$'
    },
    'BN': {
        'Note': '',
        'Country': 'Brunei',
        'Format': 'AANNNN',
        'required': true,
        'regex': '^[A-Za-z]{2}\\d{4}$'
    },
    'BG': {
        'Note': '',
        'Country': 'Bulgaria',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'BF': {
        'Note': '',
        'Country': 'Burkina Faso',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'BI': {
        'Note': '',
        'Country': 'Burundi',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'KH': {
        'Note': '',
        'Country': 'Cambodia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'CM': {
        'Note': '',
        'Country': 'Cameroon',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'CA': {
        'Note': 'The system was gradually introduced starting in April 1971 in Ottawa. The letters D, F, I, O, Q, and U are not used to avoid confusion with other letters or numbers.',
        'Country': 'Canada',
        'Format': 'ANA NAN',
        'required': true,
        'regex': '^(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\s?\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d$'
    },
    'CV': {
        'Note': 'The first digit indicates the island.',
        'Country': 'Cape Verde',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'KY': {
        'Note': '',
        'Country': 'Cayman Islands',
        'Format': 'CCN-NNNN',
        'required': true,
        'regex': '^[Kk][Yy]\\d[-\\s]?\\d{4}$'
    },
    '': {
        'Note': '',
        'Country': 'Central African Republic',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TD': {
        'Note': '',
        'Country': 'Chad',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'CL': {
        'Note': 'May only be required for bulk mail.',
        'Country': 'Chile',
        'Format': 'NNNNNNN (NNN-NNNN)',
        'required': true,
        'regex': '^\\d{3}-?\\d{4}$'
    },
    'CN': {
        'Note': 'A postal code or youbian (邮编) in a subordinate division will have the same first two digits as its governing one (see Political divisions of China. The postal services in Macau or Hong Kong Special Administrative Regions remain separate from Mainland China, with no post code system currently used.',
        'Country': 'China',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'CX': {
        'Note': 'Part of the Australian postal code system.',
        'Country': 'Christmas Island',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'CC': {
        'Note': 'Part of the Australian postal code system.',
        'Country': 'Cocos (Keeling) Island',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'CO': {
        'Note': 'First NN = 32 departments Códigos Postales | 4-72',
        'Country': 'Colombia',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'KM': {
        'Note': '',
        'Country': 'Comoros',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'CG': {
        'Note': '',
        'Country': 'Congo (Brazzaville)',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'CD': {
        'Note': '',
        'Country': 'Congo, Democratic Republic',
        'Format': '- no codes -',
        'required': false,
        'regex': '^[Cc][Dd]$'
    },
    'CK': {
        'Note': '',
        'Country': 'Cook Islands',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'CR': {
        'Note': 'First codes the provinces, next two the canton, last two the district.',
        'Country': 'Costa Rica',
        'Format': 'NNNNN (NNNN until 2007)',
        'required': true,
        'regex': '^\\d{4,5}$'
    },
    'CI': {
        'Note': '',
        'Country': "Côte d'Ivoire (Ivory Coast)",
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'HR': {
        'Note': '',
        'Country': 'Croatia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'CU': {
        'Note': 'May only be required for bulk mail. The letters CP are frequently used before the postal code. This is not a country code, but an abbreviation for "codigo postal" or postal code.',
        'Country': 'Cuba',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'CW': {
        'Note': '',
        'Country': 'Curaçao',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'CY': {
        'Note': "Post code system covers whole island, but not used in Northern Cyprus where 'Mersin 10, Turkey' is used instead.",
        'Country': 'Cyprus',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'CZ': {
        'Note': 'With Slovak Republic, Poštovní směrovací číslo (PSČ) - postal routing number.',
        'Country': 'Czech Republic',
        'Format': 'NNNNN (NNN NN)',
        'required': true,
        'regex': '^\\d{3}\\s?\\d{2}$'
    },
    'DK': {
        'Note': 'Numbering follows the dispatch of postal trains from Copenhagen.[3] Also used by Greenland, e.g.: DK-3900 Nuuk.',
        'Country': 'Denmark',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'DJ': {
        'Note': '',
        'Country': 'Djibouti',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'DM': {
        'Note': '',
        'Country': 'Dominica',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'DO': {
        'Note': '',
        'Country': 'Dominican Republic',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'TL': {
        'Note': 'No postal code system in use since Indonesian withdrawal in 1999.',
        'Country': 'East Timor',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'EL': {
        'Note': '',
        'Country': 'Ecuador',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'SV': {
        'Note': 'Used for all inbound mail to El Salvador. The postal office then distributes the mail internally depending on their destination.',
        'Country': 'El Salvador',
        'Format': '1101',
        'required': true,
        'regex': '^1101$'
    },
    'EG': {
        'Note': '',
        'Country': 'Egypt',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'GQ': {
        'Note': '',
        'Country': 'Equatorial Guinea',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'ER': {
        'Note': '',
        'Country': 'Eritrea',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'EE': {
        'Note': '',
        'Country': 'Estonia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'ET': {
        'Note': 'The code is only used on a trial basis for Addis Ababa addresses.',
        'Country': 'Ethiopia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'FK': {
        'Note': 'UK territory, but not UK postcode',
        'Country': 'Falkland Islands',
        'Format': 'AAAANAA one code: FIQQ 1ZZ',
        'required': true,
        'regex': '^[Ff][Ii][Qq]{2}\\s?[1][Zz]{2}$'
    },
    'FO': {
        'Note': 'Self-governing territory within the Kingdom of Denmark, but not Danish postcode.',
        'Country': 'Faroe Islands',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'FJ': {
        'Note': '',
        'Country': 'Fiji',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'FI': {
        'Note': 'A lower first digit indicates a place in south (for example 00100 Helsinki), a higher indicates a place further to north (99800 in Ivalo). The last digit is usually 0, except for postal codes for PO Box number ranges, in which case it is 1. Country code for Finland: "FI". In the Åland Islands, the postal code is prefixed with "AX", not "FI". Some postal codes for rural settlements may end with 5, and there are some unique postal codes for large companies and institutions, e.g. 00014 HELSINGIN YLIOPISTO (university), 00102 EDUSKUNTA (parliament), 00020 NORDEA (a major Scandinavian bank).',
        'Country': 'Finland',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'FR': {
        'Note': 'The first two digits give the département number, while in Paris, Lyon and Marseille, the last two digits of the postal code indicates the arrondissement. Both of the 2 corsican départements use "20" as the first two digits. Also used by French overseas departments and territories. Monaco is also part of the French postal code system, but the country code MC- is used for Monegasque addresses.',
        'Country': 'France',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'GF': {
        'Note': 'Overseas Department of France. French codes used. Range 97300 - 97390.',
        'Country': 'French Guiana',
        'Format': '973NN',
        'required': true,
        'regex': '^973\\d{2}$'
    },
    'PF': {
        'Note': 'Overseas Department of France. French codes used. Range 98700 - 98790.',
        'Country': 'French Polynesia',
        'Format': '987NN',
        'required': true,
        'regex': '^987\\d{2}$'
    },
    'TF': {
        'Note': 'French codes in the 98400 range have been reserved.',
        'Country': 'French Southern and Antarctic Territories',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GM': {
        'Note': '',
        'Country': 'Gambia',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GE': {
        'Note': '',
        'Country': 'Georgia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'DE': {
        'Note': "Postleitzahl (PLZ), introduced after the German reunification. Between 1989 and 1993 the old separate 4-digit postal codes of former West- and East-Germany were distinguished by preceding \"W-\" or \"O-\" ('Ost' for East).",
        'Country': 'Germany',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'GH': {
        'Note': '[citation needed]',
        'Country': 'Ghana',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GI': {
        'Note': 'Single code used for all addresses.',
        'Country': 'Gibraltar',
        'Format': 'GX11 1AA',
        'required': true,
        'regex': '^[Gg][Xx][1]{2}\\s?[1][Aa]{2}$'
    },
    'GR': {
        'Note': '',
        'Country': 'Greece',
        'Format': 'NNN NN',
        'required': true,
        'regex': '^\\d{3}\\s?\\d{2}$'
    },
    'GL': {
        'Note': 'Part of the Danish postal code system.',
        'Country': 'Greenland',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'GD': {
        'Note': '',
        'Country': 'Grenada',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GP': {
        'Note': 'Overseas Department of France. French codes used. Range 97100 - 97190.',
        'Country': 'Guadeloupe',
        'Format': '971NN',
        'required': true,
        'regex': '^971\\d{2}$'
    },
    'GU': {
        'Note': 'U.S. ZIP codes. Range 96910 - 96932.',
        'Country': 'Guam',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'GT': {
        'Note': 'The first two numbers identify the department, the third number the route and the last two the office.',
        'Country': 'Guatemala',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'GG': {
        'Note': 'UK-format postcode (first two letters are always GY not GG)',
        'Country': 'Guernsey',
        'Format': 'AAN NAA, AANN NAA',
        'required': true,
        'regex': '^[A-Za-z]{2}\\d{1,2}\\s?\\d[A-Za-z]{2}$'
    },
    'GN': {
        'Note': '',
        'Country': 'Guinea',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GW': {
        'Note': '',
        'Country': 'Guinea Bissau',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'GY': {
        'Note': '',
        'Country': 'Guyana',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'HT': {
        'Note': '',
        'Country': 'Haiti',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'HM': {
        'Note': 'Part of the Australian postcode system.',
        'Country': 'Heard and McDonald Islands',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'HN': {
        'Note': '',
        'Country': 'Honduras',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'HK': {
        'Note': '[1] The dummy postal code of Hong Kong is 999077 but it is unnecessary in fact',
        'Country': 'Hong Kong',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'HU': {
        'Note': 'The code defines an area, usually one code per settlement except the six largest towns. One code can identify more (usually) small settlements as well.',
        'Country': 'Hungary',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'IS': {
        'Note': '',
        'Country': 'Iceland',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'IN': {
        'Note': 'Postal Index Number (PIN)',
        'Country': 'India',
        'Format': 'NNNNNN,&amp;#10;NNN NNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'ID': {
        'Note': 'Kode Pos. Included East Timor (ranges 88xxx and 89xxx) until 1999, no longer used. For Indonesia postal code information visit [2]',
        'Country': 'Indonesia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'IR': {
        'Note': '(Persian: کد پستی)',
        'Country': 'Iran',
        'Format': 'NNNNN-NNNNN',
        'required': true,
        'regex': '^\\d{5}-\\d{5}$'
    },
    'IQ': {
        'Note': '',
        'Country': 'Iraq',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'IE': {
        'Note': 'Currently no postal codes; however, Dublin is divided into postal districts on syntax Dublin 9. A national post code system is planned. See also Republic of Ireland postal addresses.',
        'Country': 'Ireland',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'IM': {
        'Note': 'UK-format postcode. The first two letters are always IM.',
        'Country': 'Isle of Man',
        'Format': 'CCN NAA, CCNN NAA',
        'required': true,
        'regex': '^[Ii[Mm]\\d{1,2}\\s\\d\\[A-Z]{2}$'
    },
    'IL': {
        'Note': 'Postcode is always written BEFORE the city/place name, i.e. to the Right in Hebrew or Arabic script - to the Left in Latin script.',
        'Country': 'Israel',
        'Format': 'NNNNNNN',
        'required': true,
        'regex': '^\\d{7}$'
    },
    'IT': {
        'Note': 'Codice di Avviamento Postale (CAP). Also used by San Marino and Vatican City. First two digits identify province with some exceptions, because there are more than 100 provinces.',
        'Country': 'Italy',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'JM': {
        'Note': "Jamaica currently has no national postal code system, except for Kingston and Lower St. Andrew, which are divided into postal districts numbered 1-20[4] &amp;#10;Before the 2007 suspension, the first two letters of a national post code were always 'JM' (for Jamaica) while the third was for one of the four zones (A-D) into which the island was divided. The last two letters were for the parish, while the two digits were for the local post office.[5]",
        'Country': 'Jamaica',
        'Format': 'Before suspension: CCAAANN &amp;#10;After suspension: NN',
        'required': true,
        'regex': '^\\d{2}$'
    },
    'JP': {
        'Note': 'See also Japanese addressing system.',
        'Country': 'Japan',
        'Format': 'NNNNNNN (NNN-NNNN)',
        'required': true,
        'regex': '^\\d{3}-\\d{4}$'
    },
    'JE': {
        'Note': 'UK-format postcode.',
        'Country': 'Jersey',
        'Format': 'CCN NAA',
        'required': true,
        'regex': '^[Jj][Ee]\\d\\s?\\d[A-Za-z]{2}$'
    },
    'JO': {
        'Note': 'Deliveries to PO Boxes only.',
        'Country': 'Jordan',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'KZ': {
        'Note': '[6]',
        'Country': 'Kazakhstan',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'KE': {
        'Note': "Deliveries to PO Boxes only. The postal code refers to the post office at which the receiver's P. O. Box is located.",
        'Country': 'Kenya',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'KI': {
        'Note': '',
        'Country': 'Kiribati',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'KP': {
        'Note': '',
        'Country': 'Korea, North',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'XK': {
        'Note': 'A separate postal code for Kosovo was introduced by the UNMIK postal administration in 2004. Serbian postcodes are still widely used in the Serbian enclaves. No country code has been assigned.',
        'Country': 'Kosovo',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'KW': {
        'Note': 'The first two digits represent the sector and the last three digits represents the post office.',
        'Country': 'Kuwait',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'KG': {
        'Note': '',
        'Country': 'Kyrgyzstan',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'LV': {
        'Note': '',
        'Country': 'Latvia',
        'Format': 'LV-NNNN',
        'required': true,
        'regex': '^[Ll][Vv][- ]?\\d{4}$'
    },
    'LA': {
        'Note': '',
        'Country': 'Laos',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'LB': {
        'Note': 'The first four digits represent the region or postal zone,the last four digits represent the building see also Lebanon Postal code website.',
        'Country': 'Lebanon',
        'Format': 'NNNN NNNN',
        'required': true,
        'regex': '^\\d{4}\\s?\\d{4}$'
    },
    'LS': {
        'Note': '',
        'Country': 'Lesotho',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'LR': {
        'Note': 'Two digit postal zone after city name.',
        'Country': 'Liberia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'LY': {
        'Note': '',
        'Country': 'Libya',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'LI': {
        'Note': 'With Switzerland, ordered from west to east. Range 9485 - 9498.',
        'Country': 'Liechtenstein',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'LT': {
        'Note': 'References: http://www.post.lt/en/help/postal-code-search. Previously 9999 which was actually the old Soviet 999999 format code with the first 2 digits dropped.',
        'Country': 'Lithuania',
        'Format': 'LT-NNNNN',
        'required': true,
        'regex': '^[Ll][Tt][- ]?\\d{5}$'
    },
    'LU': {
        'Note': 'References: http://www.upu.int/post_code/en/countries/LUX.pdf',
        'Country': 'Luxembourg',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'MO': {
        'Note': '[2]',
        'Country': 'Macau',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MK': {
        'Note': '',
        'Country': 'Macedonia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'MG': {
        'Note': '',
        'Country': 'Madagascar',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'MW': {
        'Note': '',
        'Country': 'Malawi',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MV': {
        'Note': '',
        'Country': 'Maldives',
        'Format': 'NNNN, NNNNN',
        'required': true,
        'regex': '^\\d{4,5}$'
    },
    'MY': {
        'Note': '',
        'Country': 'Malaysia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'ML': {
        'Note': '',
        'Country': 'Mali',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MT': {
        'Note': 'Kodiċi Postali',
        'Country': 'Malta',
        'Format': 'AAANNNN (AAA NNNN)',
        'required': true,
        'regex': '^[A-Za-z]{3}\\s?\\d{4}$'
    },
    'MH': {
        'Note': 'U.S. ZIP codes. Range 96960 - 96970.',
        'Country': 'Marshall Islands',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'MR': {
        'Note': '',
        'Country': 'Mauritania',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MU': {
        'Note': '',
        'Country': 'Mauritius',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MQ': {
        'Note': 'Overseas Department of France. French codes used. Range 97200 - 97290.',
        'Country': 'Martinique',
        'Format': '972NN',
        'required': true,
        'regex': '^972\\d{2}$'
    },
    'YT': {
        'Note': 'Overseas Department of France. French codes used. Range 97600 - 97690.',
        'Country': 'Mayotte',
        'Format': '976NN',
        'required': true,
        'regex': '^976\\d{2}$'
    },
    'FM': {
        'Note': 'US ZIP Code. Range 96941 - 96944.',
        'Country': 'Micronesia',
        'Format': 'NNNNN or NNNNN-NNNN',
        'required': true,
        'regex': '^\\d{5}(-{1}\\d{4})?$'
    },
    'MX': {
        'Note': 'The first two digits identify the state (or a part thereof), except for Nos. 00 to 16, which indicate delegaciones (boroughs) of the Federal District (Mexico City).',
        'Country': 'Mexico',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'MD': {
        'Note': '',
        'Country': 'Moldova',
        'Format': 'CCNNNN (CC-NNNN)',
        'required': true,
        'regex': '^[Mm][Dd][- ]?\\d{4}$'
    },
    'MC': {
        'Note': 'Uses the French Postal System, but with an "MC" Prefix for Monaco.',
        'Country': 'Monaco',
        'Format': '980NN',
        'required': true,
        'regex': '^980\\d{2}$'
    },
    'MN': {
        'Note': 'First digit: region / zone&amp;#10;Second digit: province / district&amp;#10;Last three digits: locality / delivery block[7]',
        'Country': 'Mongolia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'ME': {
        'Note': '',
        'Country': 'Montenegro',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'MS': {
        'Note': '',
        'Country': 'Montserrat',
        'Format': 'MSR 1110-1350',
        'required': true,
        'regex': '^[Mm][Ss][Rr]\\s?\\d{4}$'
    },
    'MA': {
        'Note': '',
        'Country': 'Morocco',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'MZ': {
        'Note': '',
        'Country': 'Mozambique',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'MM': {
        'Note': '',
        'Country': 'Myanmar',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'NA': {
        'Note': 'Postal Code ranges from 9000-9299 (NOTE: mainly 9000 is used)',
        'Country': 'Namibia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'NR': {
        'Note': '',
        'Country': 'Nauru',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'NP': {
        'Note': '',
        'Country': 'Nepal',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'NL': {
        'Note': 'The combination of the postcode and the housenumber gives a unique identifier of the address.',
        'Country': 'Netherlands',
        'Format': 'NNNN AA',
        'required': true,
        'regex': '^\\d{4}\\s?[A-Za-z]{2}$'
    },
    'NC': {
        'Note': 'Overseas Department of France. French codes used. Range 98800 - 98890.',
        'Country': 'New Caledonia',
        'Format': '988NN',
        'required': true,
        'regex': '^988\\d{2}$'
    },
    'NZ': {
        'Note': 'Postcodes were originally intended for bulk mailing and were not needed for addressing individual items. However, new post codes for general use were phased in from June 2006 and came into force by July 2008.',
        'Country': 'New Zealand',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'NI': {
        'Note': '',
        'Country': 'Nicaragua',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'NE': {
        'Note': '',
        'Country': 'Niger',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'NG': {
        'Note': '',
        'Country': 'Nigeria',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'NU': {
        'Note': '',
        'Country': 'Niue',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'NF': {
        'Note': 'Part of the Australian postal code system.',
        'Country': 'Norfolk Island',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'MP': {
        'Note': 'U.S. ZIP codes. Range 96950 - 96952.',
        'Country': 'Northern Mariana Islands',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'NO': {
        'Note': 'From south to north',
        'Country': 'Norway',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'OM': {
        'Note': 'Deliveries to P.O. Boxes only.',
        'Country': 'Oman',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'PK': {
        'Note': 'Pakistan postal codes list',
        'Country': 'Pakistan',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'PW': {
        'Note': 'U.S. ZIP codes. All locations 96940.',
        'Country': 'Palau',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'PA': {
        'Note': '',
        'Country': 'Panama',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'PG': {
        'Note': '',
        'Country': 'Papua New Guinea',
        'Format': 'NNN',
        'required': true,
        'regex': '^\\d{3}$'
    },
    'PY': {
        'Note': '',
        'Country': 'Paraguay',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'PE': {
        'Note': '',
        'Country': 'Peru',
        'Format': 'NNNNN',
        'required': false,
        'regex': '^[a-zA-Z\u00C0-\u017F-\\d ]{1,50}$'
    },
    'PH': {
        'Note': '',
        'Country': 'Philippines',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'PN': {
        'Note': 'UK territory, but not UK postcode',
        'Country': 'Pitcairn Islands',
        'Format': 'AAAANAA one code: PCRN 1ZZ',
        'required': true,
        'regex': '^[Pp][Cc][Rr][Nn]\\s?[1][Zz]{2}$'
    },
    'PL': {
        'Note': '',
        'Country': 'Poland',
        'Format': 'NNNNN (NN-NNN)',
        'required': true,
        'regex': '^\\d{2}[- ]?\\d{3}$'
    },
    'PT': {
        'Note': '',
        'Country': 'Portugal',
        'Format': 'NNNN-NNN (NNNN NNN)',
        'required': true,
        'regex': '^\\d{4}[- ]?\\d{3}$'
    },
    'PR': {
        'Note': 'U.S. ZIP codes. ZIP codes 006XX for NW PR, 007XX for SE PR, in which XX designates the town or post office and 009XX for the San Juan Metropolitan Area, in which XX designates the area or borough of San Juan. The last four digits identify an area within the post office. For example 00716-2604: 00716-for the east section of the city of Ponce and 2604 for Aceitillo St. in the neighborhood of Los Caobos. US Post office is changing the PR address format to the American one: 1234 No Name Avenue, San Juan, PR 00901.',
        'Country': 'Puerto Rico',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'QA': {
        'Note': '',
        'Country': 'Qatar',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'RE': {
        'Note': 'Overseas Department of France. French codes used. Range 97400 - 97490.',
        'Country': 'Réunion',
        'Format': '974NN',
        'required': true,
        'regex': '^974\\d{2}$'
    },
    'RO': {
        'Note': 'Previously 99999 in Bucharest and 9999 in rest of country.',
        'Country': 'Romania',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'RU': {
        'Note': 'Placed on a line of its own.',
        'Country': 'Russia',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'BL': {
        'Note': 'Overseas Collectivity of France. French codes used.',
        'Country': 'Saint Barthélemy',
        'Format': '97133',
        'required': true,
        'regex': '^97133$'
    },
    'SH': {
        'Note': 'Single code used for all addresses.',
        'Country': 'Saint Helena',
        'Format': 'STHL 1ZZ',
        'required': true,
        'regex': '^[Ss][Tt][Hh][Ll]\\s?[1][Zz]{2}$'
    },
    'KN': {
        'Note': '',
        'Country': 'Saint Kitts and Nevis',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'LC': {
        'Note': '',
        'Country': 'Saint Lucia',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'MF': {
        'Note': 'Overseas Collectivity of France. French codes used.',
        'Country': 'Saint Martin',
        'Format': '97150',
        'required': true,
        'regex': '^97150$'
    },
    'PM': {
        'Note': 'Overseas Collectivity of France. French codes used.',
        'Country': 'Saint Pierre and Miquelon',
        'Format': '97500',
        'required': true,
        'regex': '^97500$'
    },
    'VC': {
        'Note': '',
        'Country': 'Saint Vincent and the Grenadines',
        'Format': 'CCNNNN',
        'required': true,
        'regex': '^[Vv][Cc]\\d{4}$'
    },
    'SM': {
        'Note': 'With Italy, uses a five-digit numeric CAP of Emilia Romagna. Range 47890 and 47899',
        'Country': 'San Marino',
        'Format': '4789N',
        'required': true,
        'regex': '^4789\\d$'
    },
    'ST': {
        'Note': '',
        'Country': 'Sao Tome and Principe',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SA': {
        'Note': 'A complete 13-digit code has 5-digit number representing region, sector, city, and zone; 4-digit X between 2000 and 5999; 4-digit Y between 6000 and 9999 [3]. Digits of 5-digit code may represent postal region, sector, branch, section, and block respectively [4].',
        'Country': 'Saudi Arabia',
        'Format': 'NNNNN for PO Boxes. NNNNN-NNNN for home delivery.',
        'required': true,
        'regex': '^\\d{5}(-{1}\\d{4})?$'
    },
    'SN': {
        'Note': 'The letters CP or C.P. are often written in front of the postcode. This is not a country code, but simply an abbreviation for "code postal".',
        'Country': 'Senegal',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'RS': {
        'Note': 'Poštanski adresni kod (PAK)',
        'Country': 'Serbia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'SC': {
        'Note': '',
        'Country': 'Seychelles',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SX': {
        'Note': '',
        'Country': 'Sint Maarten',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SL': {
        'Note': '',
        'Country': 'Sierra Leone',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SG': {
        'Note': 'Each building has its own unique postcode.',
        'Country': 'Singapore',
        'Format': 'NNNNNN',
        'regex': '^\\d{6}$',
        'required': true,
        'MaxLength': 6
    },
    'SK': {
        'Note': 'with Czech Republic from west to east, Poštové smerovacie číslo (PSČ) - postal routing number.',
        'Country': 'Slovakia',
        'Format': 'NNNNN (NNN NN)',
        'required': true,
        'regex': '^\\d{3}\\s?\\d{2}$'
    },
    'SI': {
        'Note': '',
        'Country': 'Slovenia',
        'Format': 'NNNN (CC-NNNN)',
        'required': true,
        'regex': '^([Ss][Ii][- ]?)?\\d{4}$'
    },
    'SB': {
        'Note': '',
        'Country': 'Solomon Islands',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SO': {
        'Note': 'A 5 digit code has been publicized, but never taken into use.',
        'Country': 'Somalia',
        'required': false,
        'Format': '- no codes -',
        'regex': ''
    },
    'ZA': {
        'Note': 'Postal codes are allocated to individual Post Office branches, some have two codes to differentiate between P.O. Boxes and street delivery addresses. Included Namibia (ranges 9000-9299) until 1992, no longer used.',
        'Country': 'South Africa',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'GS': {
        'Note': 'One code for all addresses.',
        'Country': 'South Georgia and the South Sandwich Islands',
        'Format': 'SIQQ 1ZZ',
        'required': true,
        'regex': '^[Ss][Ii][Qq]{2}\\s?[1][Zz]{2}$'
    },
    'KR': {
        'Note': '',
        'Country': 'South Korea',
        'Format': 'NNNNNN (NNN-NNN)',
        'required': true,
        'regex': '^\\d{3}-?\\d{3}$'
    },
    'ES': {
        'Note': 'First two indicate the province, range 01-52',
        'Country': 'Spain',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^(?!5100[1-5]|51070|51071|51081|5200[0-6]|5207[0-1]|52081)\\d{5}$'
    },
    'LK': {
        'Note': 'Reference: http://mohanjith.net/ZIPLook/ Incorporates Colombo postal districts, e.g.: Colombo 1 is "00100". You can search for specific postal codes here.',
        'Country': 'Sri Lanka',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'SD': {
        'Note': '',
        'Country': 'Sudan',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'SR': {
        'Note': '',
        'Country': 'Suriname',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'SZ': {
        'Note': "The letter identifies one of the country's four districts.",
        'Country': 'Swaziland',
        'Format': 'ANNN',
        'required': true,
        'regex': '^[A-Za-z]\\d{3}$'
    },
    'SE': {
        'Note': '',
        'Country': 'Sweden',
        'Format': 'NNNNN (NNN NN)',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'CH': {
        'Note': 'With Liechtenstein, ordered from west to east. In Geneva and other big cities, like Basel, Bern, Zurich, there may be one or two digits after the name of the city when the generic City code (1211) is used instead of the area-specific code (1201, 1202...), e.g.: 1211 Geneva 13. The digit identifies the post office. This addressing is generally used for P.O. box deliveries.',
        'Country': 'Switzerland',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'SJ': {
        'Note': 'Norway postal codes',
        'Country': 'Svalbard and Jan Mayen',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'SY': {
        'Note': 'A 4-digit system has been announced. Status unknown.',
        'Country': 'Syria',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TW': {
        'Note': 'The first three digits of the postal code are required; the last two digits are optional. Codes are known as youdi quhao (郵遞區號), and are also assigned to Senkaku Islands (Diaoyutai), though Japanese-administered, the Pratas Islands and the Spratly Islands. See List of postal codes in Taiwan.',
        'Country': 'Taiwan',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'TJ': {
        'Note': 'Retained system from former Soviet Union.',
        'Country': 'Tajikistan',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'TZ': {
        'Note': '',
        'Country': 'Tanzania',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TH': {
        'Note': 'The first two specify the province, numbers as in ISO 3166-2:TH, the third and fourth digits specify a district (amphoe)',
        'Country': 'Thailand',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'TG': {
        'Note': '',
        'Country': 'Togo',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TK': {
        'Note': '',
        'Country': 'Tokelau',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TO': {
        'Note': '',
        'Country': 'Tonga',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'TT': {
        'Note': 'First two digits specify a postal district (one of 72), next two digits a carrier route, last two digits a building or zone along that route',
        'Country': 'Trinidad and Tobago',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'TN': {
        'Note': '',
        'Country': 'Tunisia',
        'Format': 'NNNN',
        'required': true,
        'regex': '^\\d{4}$'
    },
    'TR': {
        'Note': 'First two digits are the city numbers.[8]',
        'Country': 'Turkey',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'TM': {
        'Note': 'Retained system from former Soviet Union.',
        'Country': 'Turkmenistan',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'TC': {
        'Note': 'Single code used for all addresses.',
        'Country': 'Turks and Caicos Islands',
        'Format': 'TKCA 1ZZ',
        'required': true,
        'regex': '^[Tt][Kk][Cc][Aa]\\s?[1][Zz]{2}$'
    },
    'TV': {
        'Note': '',
        'Country': 'Tuvalu',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'UG': {
        'Note': '',
        'Country': 'Uganda',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'UA': {
        'Note': '',
        'Country': 'Ukraine',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'AE': {
        'Note': '',
        'Country': 'United Arab Emirates',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'GB': {
        'Note': 'Known as the postcode. The first letter(s) indicate the postal area, such as the town or part of London. Placed on a separate line below the city (or county, if used). The UK postcode is made up of two parts separated by a space. These are known as the outward postcode and the inward postcode. The outward postcode is always one of the following formats: AN, ANN, AAN, AANN, ANA, AANA, AAA. The inward postcode is always formatted as NAA. A valid inward postcode never contains the letters: C, I, K, M, O or V. The British Forces Post Office has a different system, but as of 2012 has also adopted UK-style postcodes that begin with "BF1" for electronic compatibility.',
        'Country': 'United Kingdom',
        'Format': 'A(A)N(A/N)NAA (A[A]N[A/N] NAA)',
        'required': true,
        'regex': '^[a-zA-Z][a-zA-Z]?\\d[a-zA-Z\\d]?\\s\\d[a-zA-Z]{2}$',
        'MaxLength': 10
    },
    'US': {
        'Note': 'Known as the ZIP Code with five digits 99999* or the ZIP+4 Code with nine digits 99999-9999* (while the minimum requirement is the first five digits, the U.S. Postal Service encourages everyone to use all nine). Also used by the former US Pacific Territories: Federated States of Micronesia; Palau; and the Marshall Islands, as well as in current US territories American Samoa, Guam, Northern Mariana Islands, Puerto Rico, and the United States Virgin Islands. An individual delivery point may be represented as an 11-digit number, but these are usually represented by Intelligent Mail barcode or formerly POSTNET bar code.',
        'Country': 'United States',
        'Format': 'NNNNN (optionally NNNNN-NNNN)',
        'required': true,
        'regex': '^\\d{5}(?:[- ]{1}\\d{4})?$',
        'MaxLength': 10
    },
    'UY': {
        'Note': '',
        'Country': 'Uruguay',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'VI': {
        'Note': 'U.S. ZIP codes. Range 00801 - 00851.',
        'Country': 'U.S. Virgin Islands',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'UZ': {
        'Note': 'Почтовые индексы',
        'Country': 'Uzbekistan',
        'Format': 'NNN NNN',
        'required': true,
        'regex': '^\\d{3} \\d{3}$'
    },
    'VU': {
        'Note': '',
        'Country': 'Vanuatu',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'VA': {
        'Note': 'Single code used for all addresses. Part of the Italian postal code system.',
        'Country': 'Vatican',
        'Format': '120',
        'required': true,
        'regex': '^120$'
    },
    'VE': {
        'Note': '',
        'Country': 'Venezuela',
        'Format': 'NNNN or NNNN A',
        'required': true,
        'regex': '^\\d{4}(\\s[a-zA-Z]{1})?$'
    },
    'VN': {
        'Note': 'First two indicate a province.',
        'Country': 'Vietnam',
        'Format': 'NNNNNN',
        'required': true,
        'regex': '^\\d{6}$'
    },
    'WF': {
        'Note': 'Overseas Department of France. French codes used. Range 98600 - 98690.',
        'Country': 'Wallis and Futuna',
        'Format': '986NN',
        'required': true,
        'regex': '^986\\d{2}$'
    },
    'YE': {
        'Note': "System for Sana'a Governorate using geocoding \"عنواني\" based on the OpenPostcode algorithm is inaugurated in 2014.[9]",
        'Country': 'Yemen',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    },
    'ZM': {
        'Note': '',
        'Country': 'Zambia',
        'Format': 'NNNNN',
        'required': true,
        'regex': '^\\d{5}$'
    },
    'ZW': {
        'Note': 'System is being planned.',
        'Country': 'Zimbabwe',
        'Format': '- no codes -',
        'required': false,
        'regex': ''
    }
};
